<form [formGroup]="form">
    <div class="row equal">
      <div *ngFor="let question of questions" class="col-xs-12 col-sm-{{question.size}} ">
            <dynamic-form-field [form]="form" [question]="question" (onChangeValue) = "onRetrieve($event)"></dynamic-form-field>
        </div>
    </div>

</form>
